// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kNQA","label":"styles_label__VqVgG"};